import { apiClient } from './api'

export type NpsPromptReason =
  | 'trial_day_7'
  | 'trial_day_30'
  | 'quarterly'
  | 'manual'

export interface NpsEligibility {
  eligible: boolean
  prompt_reason: NpsPromptReason | null
}

export interface NpsResponse {
  id: number
  organization_id: number | null
  user_id: number | null
  score: number
  comment: string | null
  prompt_reason: NpsPromptReason
  created_at: string
}

export interface NpsAdminSummary {
  window_days: number
  total_responses: number
  promoters: number
  passives: number
  detractors: number
  nps_score: number
  recent_comments: NpsResponse[]
}

export const npsService = {
  eligibility: async (): Promise<NpsEligibility> => {
    const { data } = await apiClient.get<NpsEligibility>('/api/v1/nps/eligibility')
    return data
  },
  submit: async (input: {
    score: number
    comment?: string | null
    prompt_reason: NpsPromptReason
  }): Promise<NpsResponse> => {
    const { data } = await apiClient.post<NpsResponse>('/api/v1/nps/responses', input)
    return data
  },
  dismiss: async (prompt_reason: NpsPromptReason): Promise<void> => {
    await apiClient.post('/api/v1/nps/dismiss', { prompt_reason })
  },
  adminSummary: async (windowDays = 90): Promise<NpsAdminSummary> => {
    const { data } = await apiClient.get<NpsAdminSummary>(
      `/api/v1/nps/admin/summary?window_days=${windowDays}`,
    )
    return data
  },
  adminList: async (params?: {
    score_min?: number
    score_max?: number
    prompt_reason?: NpsPromptReason
    limit?: number
  }): Promise<NpsResponse[]> => {
    const { data } = await apiClient.get<NpsResponse[]>('/api/v1/nps/admin/responses', {
      params,
    })
    return data
  },
}
